import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { ErrorFilled } from '@assets';

const Page500 = () => {
    const { t } = useTranslation()

    return (
        <Result
            title="Oops!"
            subTitle={t("error.subtitle500")}
            icon={<ErrorFilled />}
            extra={
                <Button
                    type="primary"
                    onClick={() => window.location.reload()}
                >
                    {t("error.retry")}
                </Button>
            }
        />
    );
}

export default Page500;